import type * as React from 'react';

function SvgAZ(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M9.70573 17H6.96001L6.75334 15.7256H4.96715L4.74572 17H2L4.37667 7H7.6243L9.70573 17ZM5.32144 13.5967H6.44334C6.23668 12.2024 6.05953 10.8081 5.94144 9.3988C5.88239 9.86357 5.8381 10.3433 5.77906 10.8081C5.6462 11.7376 5.49858 12.6672 5.32144 13.5967Z"
        fill="currentColor"
      />
      <path d="M14.0524 14.2114H10.8491V12.2024H14.0524V14.2114Z" fill="currentColor" />
      <path
        d="M22 7V7.28486C20.8929 9.77361 19.83 12.2774 18.6343 14.7211C19.6529 14.6312 20.6567 14.6312 21.6752 14.6012V17H14.8995V16.7901L17.0105 11.9025C17.3943 11.018 17.8224 10.1634 18.339 9.35382H15.4752V7H22Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgAZ;
